export const directorInnerStatic = {
  main_decription: 'Director:',
  crumbsNav: [
    { id: 1, title: 'Home', link: '/' },
  ],
  tickers: ['Reel', 'Reel', 'Reel', 'Reel', 'Reel', 'Reel', 'Reel', 'Reel'],
  bio_marker: 'About Director',
};
